import classNames from "classnames";
import { getLocalizedString } from "common/components/localization";
import { GlideFC } from "lib/glide-fc";
import { FormElementStyle } from "./form-element-style";

export interface FormElementProps {
    title?: string;
    isEnabled?: boolean;
    isRequired?: boolean;
    errorMessage?: string;
    hint?: string;
}

const FormElement: GlideFC<React.PropsWithChildren<FormElementProps>> = props => {
    const { isEnabled = true, isRequired = false, title, children, errorMessage, hint } = props;

    const fullHint = errorMessage ?? hint;
    const showLabels = (title !== undefined && title !== "") || (fullHint !== undefined && fullHint !== "");

    return (
        <FormElementStyle
            className={classNames({
                error: errorMessage !== undefined,
            })}
            isEnabled={isEnabled}>
            {showLabels && (
                <div className="labels">
                    {title && <div className="label">{title}</div>}
                    {isRequired && <span>{getLocalizedString("required")}</span>}
                </div>
            )}
            {children}
            {fullHint && <caption>{fullHint}</caption>}
        </FormElementStyle>
    );
};

export default FormElement;
